import Model, { attr, belongsTo, hasMany } from "@ember-data/model";
import type BioExamOrder from "parog-web/models/bio-exam-order";
import type PrescriptionConfiguration from "parog-web/models/prescription-configuration";

export default class BioExamReportTemplate extends Model {
  @hasMany("bio-exam-order", {
    async: false,
    inverse: "bioExamReportTemplates"
  })
  declare bioExamOrders: BioExamOrder[];
  @attr() declare followUpReasons: string[];
  @attr("string") declare frequency?: string;
  @belongsTo("prescription-configuration", {
    async: false,
    inverse: "bioExamReportTemplates"
  })
  declare prescriptionConfiguration: PrescriptionConfiguration;
  @attr("string") declare title: string;
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "bio-exam-report-template": BioExamReportTemplate;
  }
}
